export default __webpack_public_path__ + "62ab16fd3a0f6c9a263b3a4cd713bf6b.png";